import styled from '@emotion/styled';
import { Modal } from 'react-bootstrap';

export const ModalFooter = styled(Modal.Footer)({ padding: '0.75rem' });
